import { DEBUG } from '@glimmer/env';
import { SafeString } from 'handlebars/dist/handlebars';

export function cFeatureImage(altText, imgSrc) {
  if (DEBUG) {
    if (!altText) {
      console.error(
        `Missing \`c-feature-image\` alt text! Important!: this error will not
        appear on prod; please be sure to include an image alt text for
        accessibility requirements.`
      );
    }
    if (!imgSrc) {
      console.error('Missing `c-feature-image` src URL!');
    }
  }
  return new SafeString(
    `<div class="c-feature__image-box"><img alt="${altText}" class="c-feature__image" src="${imgSrc}" /></div>`,
  );
}
